import courseone from "../../assets/img/courseone.png";
import coursetwo from "../../assets/img/coursetwo.png";
import coursethree from "../../assets/img/coursethree.png";
import coursefour from "../../assets/img/coursefour.png";
import coursefive from "../../assets/img/coursefive.png";

// Course data that can be imported and used across components
export const ENROLLMENT_FORM_URL =
  "https://forms.gle/your-enrollment-form-link";

export const coursesData = [
  {
    id: "digital-literacy",
    title: "Digital Literacy",
    description:
      "This course is designed to introduce learners to the world of technology in a way that's simple, fun, and easy to understand. It covers the basics of using a computer from how to turn it on and type properly to exploring essential tools like word processors and web browsers. Learners will also be introduced to internet safety, how to search for information online, and how to use digital tools responsibly. Digital Literacy builds a strong foundation for any tech-related learning and helps develop the confidence to use technology in everyday life, school, and future careers.",
    duration: "4 weeks",
    age: "8 to 17",
    price: "₦35,000",
    requirements: "A laptop and internet connection",
    image: courseone,
    category: "Fundamentals",
    curriculumFile: "/curricula/digital-literacy-curriculum.pdf",
    roadmapFile: "/roadmaps/digital-literacy-roadmap.pdf",
  },
  {
    id: "web-design",
    title: "Web Design",
    description:
      "Web Design teaches how to build websites from scratch using simple and engaging tools. This course introduces the basics of web layout, how to organize content, add pictures and text, and create visually appealing pages. Learners will get hands-on experience using beginner-friendly web builders and gain a basic understanding of how websites function. By the end of the course, they'll be able to create and show off their own mini website, boosting digital confidence and creativity while learning a highly relevant skill in today's tech-driven world.",
    duration: "4 weeks",
    age: "8 to 17",
    price: "₦35,000",
    requirements: "A laptop and internet connection",
    image: coursetwo,
    category: "Design",
    curriculumFile: "/curricula/web-design-curriculum.pdf",
    roadmapFile: "/roadmaps/web-design-roadmap.pdf",
  },
  {
    id: "video-animation",
    title: "Video Animation",
    description:
      "In the Video Animation course, imagination meets technology. Learners will explore how to tell stories through motion by creating their own animated videos. They'll learn how to draw or use simple characters, make them move, add voiceovers, background music, and more. Using beginner-friendly tools, this course breaks down animation into easy steps that anyone can follow. It encourages creativity, storytelling, and digital media skills; all while having fun bringing ideas to life on screen.",
    duration: "4 weeks",
    age: "8 to 17",
    price: "₦35,000",
    requirements: "A laptop and internet connection",
    image: coursethree,
    category: "Creative",
    curriculumFile: "/curricula/video-animation-curriculum.pdf",
    roadmapFile: "/roadmaps/video-animation-roadmap.pdf",
  },
  {
    id: "product-design",
    title: "Product Design",
    description:
      "Product Design is all about creativity, innovation, and bringing ideas to life. In this course, learners will be guided through the process of thinking like a young inventor: spotting everyday problems and figuring out how to solve them by designing simple products or solutions. Through hands-on projects, they'll learn how to plan, sketch, test ideas, and improve on them. This course encourages curiosity, critical thinking, and confidence in the ability to create something meaningful. It's a great way to introduce the mindset of a designer or entrepreneur early on.",
    duration: "4 weeks",
    age: "8 to 17",
    price: "₦35,000",
    requirements: "A laptop and internet connection",
    image: coursefour,
    category: "Design",
    curriculumFile: "/curricula/product-design-curriculum.pdf",
    roadmapFile: "/roadmaps/product-design-roadmap.pdf",
  },
  {
    id: "python-programming",
    title: "Python Programming",
    description:
      "Python is one of the easiest programming languages to learn, making it perfect for beginners. This course introduces the exciting world of coding by teaching how to write simple Python programs through engaging activities like creating games, solving puzzles, and building small digital projects. As learners progress, they begin to understand how technology is built and how to think like a developer. Beyond just writing code, this course also helps sharpen logical thinking, creativity, and problem-solving skills; all of which are useful in and out of the tech world.",
    duration: "4 weeks",
    age: "8 to 17",
    price: "₦35,000",
    requirements: "A laptop and internet connection",
    image: coursefive,
    category: "Programming",
    curriculumFile: "/curricula/python-programming-curriculum.pdf",
    roadmapFile: "/roadmaps/python-programming-roadmap.pdf",
  },
];

export const getRelatedCourses = (currentCourseId, limit = 2) => {
  return coursesData
    .filter((course) => course.id !== currentCourseId)
    .slice(0, limit);
};

export const getCourseById = (id) => {
  return coursesData.find((course) => course.id === id);
};
